import { BaseModel } from './base';

export class BankBranch extends BaseModel {
  bankId: string;
  location: string;
  branchName: string;
  landMark: string;
}
